import { t } from '../i18n.js';

interface Props {
  onSetTemperature: () => void;
  busy: boolean;
}

export function ActionRow({ onSetTemperature, busy }: Props) {
  return (
    <div className="actions">
      <button
        className="btn-primary"
        onClick={onSetTemperature}
        disabled={busy}
      >
        {t('action.set_temp')}
      </button>
    </div>
  );
}
